// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choice-option .isAnswer i[data-v-50e93db3]{border:5px solid #1890ff}.choice-option .isAnswer span[data-v-50e93db3]{color:#1890ff}.active.isAnswer i[data-v-50e93db3]{border:5px solid #3c3}.active.isAnswer span[data-v-50e93db3]{color:#3c3}.choice-option.error[data-v-50e93db3]{border-color:red}.active.error i[data-v-50e93db3]{border:5px solid red}.active.error span[data-v-50e93db3]{color:red}", ""]);
// Exports
module.exports = exports;
